export interface MusicStreamSource {
  bitRate: string;
  name: string;
  type: string;
  url: string;
  genre: string;
}

export interface ApiMusicStreamSource {
  BitRate: string;
  Name: string;
  Type: string;
  Url: string;
  Genre: string | Object;
}

export interface MusicStreamSourceBrowseParams {
  url?: string;
  genre?: string;
  limit?: string;
}

export function apiMusicStreamSourceToMusicStreamSource(
  data: ApiMusicStreamSource
): MusicStreamSource {
  return {
    bitRate: data.BitRate,
    name: data.Name,
    type: data.Type,
    url: data.Url,
    genre: typeof data.Genre === "string" && !!data.Genre ? data.Genre : "Not specified"
  };
}
